// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nnav.v-navigation-drawer[data-v-38af7ae0] {\n  /* Need !important as a max-height derived from the footer being always\n     visible is applied directly to element by vuetify */\n  max-height: 100vh !important;\n  /* z-index hides behind footer and topbar */\n  z-index: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
